import { useEffect } from "react"

export function useHashNavigation() {
  useEffect(() => {
    function scrollToHash() {
      const hash = window.location.hash.replace("#", "")
      if (!hash) return
      const el = document.getElementById(hash)
      if (!el) return

      // Use scrollIntoView without block parameter to respect CSS scroll-margin
      el.scrollIntoView({ behavior: "smooth" })
    }

    // Initial run (page loaded with a hash)
    // Some layout (images, fonts) might not have finished yet, so we do a
    // second attempt on the next tick to guarantee we hit the right spot.
    scrollToHash()
    const timer = setTimeout(scrollToHash, 120)

    // Listen for subsequent hash changes (in-page navigation)
    window.addEventListener("hashchange", scrollToHash)
    return () => {
      window.removeEventListener("hashchange", scrollToHash)
      clearTimeout(timer)
    }
  }, [])
}
